import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-6 md:px-10 py-10 md:py-14 bg-background-100/70">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-sm font-medium text-foreground-600 tracking-wider uppercase mb-3">
            All Categories
          </p>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            Explore Every Category
          </h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 rounded-xl border border-background-200/50 hover:border-primary-300 hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-lg`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 text-center whitespace-nowrap group-hover:text-primary-500 transition-colors">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}